export default function ChildModal({ active = false, children }) {
  return (
    <>
      <div className={active ? 'modals active' : 'modals'}>{children}</div>
      {active && <div className="mask show" />}
    </>
  )
}
